const GET_COLLECTION_DETAILS = "GET_COLLECTION_DETAILS";
const GET_COLLECTION_DETAILS_SUCCESS = "GET_COLLECTION_DETAILS_SUCCESS";
const GET_COLLECTION_DETAILS_FAILURE = "GET_COLLECTION_DETAILS_FAILURE";
const CLEAR_GET_COLLECTION_DETAILS = "CLEAR_GET_COLLECTION_DETAILS";

const collectionDetailsSymbols = {
  GET_COLLECTION_DETAILS_SUCCESS,
  GET_COLLECTION_DETAILS_FAILURE,
  GET_COLLECTION_DETAILS,
  CLEAR_GET_COLLECTION_DETAILS,
};
export default collectionDetailsSymbols;
